/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

export const initiatePayment = async (planType: string): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const userId = useUserStore.getState().userDetails?._id;
  const companyId = useCompanyStore.getState().companyId;

  try {
    const response: any = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.razorCreatePayment}/${companyId}/${userId}/${planType}`,
      data: {},
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    const data = response.data;

    return data;
  } catch (err) {
    return await Promise.reject(new Error('Something wrong'));
  }
};

export const verifyPayment = async (
  payload: Record<string, any>
): Promise<{success: boolean; msg: string}> => {
  const token = useUserStore.getState().userToken;

  try {
    const response: any = await axios.request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.razorVerifyPayment}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    if (response?.data?.status !== 'OK') {
      const errorData = await response;
      throw new Error(
        errorData.message || `Payment verification failed (${response.status}).`
      );
    }

    const data = response.data;

    return {success: true, msg: data?.msg ?? 'Payment Success'};
  } catch (err) {
    return await Promise.reject(new Error('Payment verification failed'));
  }
};
